exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#export{background-position:0 0;background-size:cover;width:816px;height:1056px;padding:170px 90px 96px;text-align:justify;font-family:Calibri,sans-serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03057b35","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/school/services/digital_document.vue
// module id = ddd8
// module chunks = 2